import styled from "styled-components";
import { Box } from "@material-ui/core";

export const CreativeToolbarContainer = styled(Box)`
    .MuiButtonBase-root {
        padding: ${({ theme }) => theme.spacing(0.5)}px;
    }
`;
